const isLoggerEnabled = true; // Easily enable/disable console logger

const Logger = {
  log : function(...params) {
    if (isLoggerEnabled) console.log(...params);
  },
  error : function(...params) {
    if (isLoggerEnabled) console.error(...params);
  },
};

export default Logger;
